module.exports = __webpack_public_path__ + "img/twitter.1f4e0874.svg";